"use client";

let access = null;
let accessExp = null;

const KEY = "accessToken";

const isBrowser = () => typeof window !== "undefined";

function parseExp(jwt) {
  try {
    const part = (jwt?.split(".")[1] || "")
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const payload = JSON.parse(atob(part));
    const expMs = Number(payload?.exp) * 1000;
    return Number.isFinite(expMs) ? expMs : null;
  } catch {
    return null;
  }
}

function loadFromStorage() {
  if (!isBrowser()) return null;
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function saveToStorage(token) {
  if (!isBrowser()) return;
  try {
    if (token) sessionStorage.setItem(KEY, token);
    else sessionStorage.removeItem(KEY);
  } catch {}
}

export function setAccessToken(a) {
  access = a || null;
  accessExp = a ? parseExp(a) : null;
  saveToStorage(access);
}

export function getAccess() {
  if (access) return access;

  // hydrate once after refresh
  const stored = loadFromStorage();
  if (stored) {
    access = stored;
    accessExp = parseExp(stored);
  }
  return access;
}

export function isAccessExpired(skewMs = 30_000) {
  const t = getAccess();
  if (!t) return true;

  // If token has no exp, treat as expired (your policy)
  if (!accessExp) accessExp = parseExp(t);
  if (!accessExp) return true;

  return accessExp - Date.now() <= skewMs;
}

export function logout() {
  access = null;
  accessExp = null;
  saveToStorage(null);
}
